import packageJson from '../../package.json';

export default {
  okta: {
    baseUrl: 'https://tempus.oktapreview.com',
    issuer: 'ausfjxf2zb85ZfrrS0h7',
    clientId: '0oa1xh8sgr0SVVimL0h8',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedClientIds: {
    clinicalPortal: '0oa124s664mOLRgi20h8',
    lensGlass: '0oaeqck2ljsd5rnfB0h7',
    lensNotebook: '0oamc9v0naJv40dpJ0h7',
    lensNotebook2: '0oaqeg8y8nxQSeGnD0h7',
    accountUi: '0oa1xh8sgr0SVVimL0h8',
    therapiesSites: '0oay76aqq81grAMlV0h7',
    therapiesSponsors: '0oay8x02x9opXbl9O0h7',
    trialsApp: '0oay762v4jqeucIXU0h7',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedIssuerIds: {
    default: 'ausfjxf2zb85ZfrrS0h7',
    demo: 'ausljcfleg4KQAT5C0h7',
    stagingDemo: 'ausigvgms1mmEKe8Q0h7',
  },
  apps: {
    clinicalPortal: 'https://hub.stagingtempus.com',
    lens: 'https://lens.stagingtempus.com',
    pixelRad: 'https://pixel-rad.stagingtempus.com',
    therapiesSites: 'https://link-sites.stagingtempus.com',
    therapiesSponsors: 'https://link-sponsors.stagingtempus.com',
    providerAccount: 'https://provider-account.stagingtempus.com',
    trialsApp: 'https://trials.stagingtempus.com/',
    ehrIntegrationService: 'https://ehr-integration-service.stagingtempus.com',
    david: 'https://david.stagingtempus.com',
  },
  sentry: {
    dsn: 'https://9f8e11e5fbfa4b40b3d703fc2b8e847f@o816116.ingest.sentry.io/4504730124288000',
    environment: 'bet',
    enabled: true,
    release: `${packageJson.name}@${packageJson.version}`,
  },
  whitelistedRedirectDomain: [
    '.stagingtempus.com',
    '.alp.gcp.tempus.cloud',
    '.bet.gcp.tempus.cloud',
    '.devtempus.com:3001',
    '.devtempus.com',
    '.demotempus.com',
    'localhost:3000',
    'localhost:4470',
    '.devtempus.com:4470',
    '.devtempus.com',
    'localhost',
  ],
};
